import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import {
  fetchDashboardsFromApi,
  getDashboardsQueryKey,
  type UseDashboardsOptions,
} from "./utils";

export function useDashboards(options: UseDashboardsOptions = {}) {
  const { selectedOrganisation } = useSelectedStores();
  const isEnabled = options.enabled ?? true;

  const query = useQuery({
    queryKey: getDashboardsQueryKey(selectedOrganisation),
    queryFn: () =>
      selectedOrganisation
        ? fetchDashboardsFromApi(selectedOrganisation)
        : Promise.resolve([]),
    enabled: Boolean(selectedOrganisation && isEnabled),
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });

  const dashboards = useMemo(() => query.data ?? [], [query.data]);

  return {
    ...query,
    dashboards,
    isLoading: query.isLoading,
  };
}
